import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  { label: '分类', path: '/category' },
  { label: '搜索', path: '/search' },
  { label: '关于', path: '/about' },
];

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const isHome = location.pathname === '/';
  const transparent = isHome && !scrolled && !mobileOpen;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-[100] transition-all duration-300 ${
        transparent
          ? 'bg-transparent'
          : 'bg-background-50/90 backdrop-blur-md border-b border-background-200/70'
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 md:h-[68px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5 shrink-0">
          <span
            className={`w-9 h-9 rounded-lg flex items-center justify-center text-lg transition-colors ${
              transparent ? 'bg-background-50/20 text-background-50' : 'bg-primary-500 text-background-50'
            }`}
          >
            <i className="ri-film-line" />
          </span>
          <span className={`flex flex-col leading-none ${transparent ? 'text-background-50' : 'text-foreground-950'}`}>
            <span className="font-heading font-bold text-base tracking-wide">善良影视</span>
            <span className={`text-[11px] mt-0.5 ${transparent ? 'text-background-50/80' : 'text-foreground-500'}`}>
              善良的小姨子在线播放
            </span>
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navItems.map((item) => {
            const active = item.path === '/' ? location.pathname === '/' : location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  transparent
                    ? active
                      ? 'text-background-50 bg-background-50/15'
                      : 'text-background-50/85 hover:text-background-50 hover:bg-background-50/10'
                    : active
                      ? 'text-primary-700 bg-primary-50'
                      : 'text-foreground-700 hover:text-primary-700 hover:bg-background-100'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </div>

        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/search"
            className={`w-9 h-9 rounded-md flex items-center justify-center text-lg transition-colors ${
              transparent
                ? 'text-background-50 hover:bg-background-50/10'
                : 'text-foreground-600 hover:bg-background-100'
            }`}
            aria-label="搜索"
          >
            <i className="ri-search-line" />
          </Link>
          <Link
            to="/category"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
          >
            开始观看
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md text-2xl ${
            transparent ? 'text-background-50' : 'text-foreground-900'
          }`}
          aria-label="菜单"
        >
          <i className={mobileOpen ? 'ri-close-line' : 'ri-menu-line'} />
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 pb-4">
          <div className="flex flex-col py-2">
            {navItems.map((item) => {
              const active = item.path === '/' ? location.pathname === '/' : location.pathname.startsWith(item.path);
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  className={`px-3 py-3 rounded-md text-sm font-medium ${
                    active ? 'text-primary-700 bg-primary-50' : 'text-foreground-700'
                  }`}
                >
                  {item.label}
                </Link>
              );
            })}
          </div>
          <Link
            to="/category"
            className="block text-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
          >
            开始观看
          </Link>
        </div>
      )}
    </header>
  );
}